<div class="pb-5">
    <h1>{{ 'DOCUMENTS.ACCESS.TITLE' | translate }}</h1>
    <div class="mt-1 mb-2">
        <button (click)="openCreateModal('department', addPermissionsView)"
                [disabled]="isPermissionsChanged"
                class="btn btn-primary ms-1"
                data-action='addDepartment'
        >
            {{ 'DOCUMENTS.BUTTONS.ADD_DEPARTMENT' | translate }}
        </button>
        <button (click)="openCreateModal('division', addPermissionsView)"
                [disabled]="isPermissionsChanged"
                class="btn btn-primary ms-1"
                data-action='addMember'
        >
            {{ 'DOCUMENTS.BUTTONS.ADD_DIVISION' | translate }}
        </button>
        <button (click)="openCreateModal('member', addPermissionsView)"
                [disabled]="isPermissionsChanged"
                class="btn btn-primary ms-1"
                data-action='addDivision'
        >
            {{ 'DOCUMENTS.BUTTONS.ADD_MEMBER' | translate }}
        </button>
    </div>
    <table class="table default-table table-tasks gbo_shadow">
        <thead>
        <tr>
            <td>
                <strong>{{ 'DOCUMENTS.ACCESS.TYPE' | translate }}</strong>
            </td>
            <td>
                <strong>{{ 'DOCUMENTS.ACCESS.NAME' | translate }}</strong>
            </td>
            <td *ngFor="let colon of colons">
                <strong>{{ 'DOCUMENTS.ACCESS.' + colon.right | translate }}</strong>
            </td>
            <td></td>
        </tr>
        </thead>
        <tbody>
        <tr class="table-info">
            <td colspan="14"><strong>{{ 'DOCUMENTS.ACCESS.DEPARTMENTS' | translate }}</strong></td>
        </tr>
        <ng-container
                *ngTemplateOutlet="perms; context: {allPermissions: departments, permissionsType: 'departments'}"
        ></ng-container>

        <tr class="table-info">
            <td colspan="14"><strong>{{ 'DOCUMENTS.ACCESS.DIVISIONS' | translate }}</strong></td>
        </tr>
        <ng-container
                *ngTemplateOutlet="perms; context: {allPermissions: divisions, permissionsType: 'divisions'}"
        ></ng-container>

        <tr class="table-info">
            <td colspan="14"><strong>{{ 'DOCUMENTS.ACCESS.MEMBERS' | translate }}</strong></td>
        </tr>
        <ng-container
                *ngTemplateOutlet="perms; context: {allPermissions: members, permissionsType: 'members'}"
        ></ng-container>

        <ng-template #perms
                     let-allPermissions="allPermissions"
                     let-permissionsType="permissionsType">
            <tr *ngIf="!allPermissions.length">
                <td class="align-center"
                    colspan="14">
                    <i>{{ 'EMPTY_LISTS.EMPTY' | translate }}</i>
                </td>
            </tr>
            <tr *ngFor="let permission of allPermissions; let i = index"
                class="table-item table-light">
                <td>
                    <i *ngIf="permission.role_type === 'department'"
                       class="bi bi-collection"
                       ngbTooltip="{{ 'DOCUMENTS.ACCESS.DEPARTMENT' | translate }}"></i>
                    <i *ngIf="permission.role_type === 'member'"
                       class="bi bi-person"
                       ngbTooltip="{{ 'DOCUMENTS.ACCESS.MEMBER' | translate }}"></i>
                    <i *ngIf="permission.role_type === 'division'"
                       class="bi bi-people"
                       ngbTooltip="{{ 'DOCUMENTS.ACCESS.DIVISION' | translate }}"></i>
                </td>
                <td>
                    <span (click)="helper.openProfileByGuid(permission.role.guid)"
                          *ngIf="permission.role_type === 'member'"
                          [class.blocked_user]="permission.role.observation_type === 'blocked'"
                          [class.inactive_user]="!permission.role.is_active"
                          class="user_name"
                    >
                        {{ helper.shortFullName(permission.role) }}
                    </span>
                    <span *ngIf="['division', 'department'].includes(permission.role_type)">{{ permission.role.name }}</span>
                </td>
                <td *ngFor="let perms of colons"
                    style="text-align: center"
                >
                    <select #permissionSelect
                            (change)="changePermissions(permission, perms.right, permissionSelect.value)"
                            [class.disabled]="!perms.is_editing"
                            [class.permission-changed]="copyPermissions[permissionsType][i][perms.right] !== permission[perms.right]"
                            [class]="permission[perms.right] ? 'active' : 'admin'"
                            class="form-select-sm"
                            data-action="changeIsReadAllTasks"
                    >
                        <option [selected]="copyPermissions[permissionsType][i][perms.right] === 'succession'"
                                value="succession"
                        >
                            {{ 'TASKS.SETTINGS.ACCESS.VALUE.succession'| translate }}
                        </option>
                        <option [selected]="copyPermissions[permissionsType][i][perms.right] === 'allowed'"
                                value="allowed"
                        >
                            {{ 'TASKS.SETTINGS.ACCESS.VALUE.allowed'| translate }}
                        </option>
                        <option [selected]="copyPermissions[permissionsType][i][perms.right] === 'denied'"
                                value="denied"
                        >
                            {{ 'TASKS.SETTINGS.ACCESS.VALUE.denied'| translate }}
                        </option>
                    </select>
                </td>

                <td style="text-align: center">
                    <button (click)="deleteAccess(permission)"
                            [disabled]="isPermissionsChanged"
                            class="btn btn-danger btn-sm"
                    >
                        <i class="bi bi-trash"></i>
                    </button>
                </td>
            </tr>
        </ng-template>
        </tbody>
    </table>
</div>

<div *ngIf="isPermissionsChanged"
     class="fixed-button">
    <div class="btn-group btn-block w-100">
        <button (click)="savePermissions()"
                class="btn btn-success"
                data-action="saveRoadmapButton"
        >
            {{ 'BUTTON_TEXT.SAVE' | translate }}
        </button>
        <button (click)="cancelEditPermissions()"
                class="btn btn-primary"
                data-action="clearRoadmapChangesButton"
        >
            {{ 'BUTTON_TEXT.REVERT' | translate }}
        </button>
    </div>
</div>

<ng-template #addPermissionsView
             let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <ng-container [ngSwitch]="roleType">

            <ng-template ngSwitchCase="member">
                <h1>{{ 'MODALS.HEADERS.ADD_MEMBER' | translate }}</h1>
                <select #memberKey
                        (change)="roleKey = memberKey.value"
                        class="form-select">
                    <option hidden
                            selected
                            value="">{{ 'MODALS.FIELDS.SELECT.MEMBER' | translate }}
                    </option>
                    <option *ngIf="!allMembers.length"
                            disabled>{{ 'EMPTY_LISTS.EMPTY' | translate }}
                    </option>
                    <option *ngFor="let member of allMembers"
                            [value]="member.guid"
                    >
                        {{ helper.shortFullName(member) }}
                    </option>
                </select>
            </ng-template>

            <ng-template ngSwitchCase="department">
                <h1>{{ 'MODALS.HEADERS.ADD_DEPARTMENT' | translate }}</h1>
                <select #departmentKey
                        (change)="roleKey = departmentKey.value"
                        class="form-select">
                    <option hidden
                            selected
                            value="">{{ 'MODALS.FIELDS.SELECT.DEPARTMENTS' | translate }}
                    </option>
                    <option *ngIf="!allDepartments.length"
                            disabled>{{ 'EMPTY_LISTS.EMPTY' | translate }}
                    </option>
                    <option *ngFor="let department of allDepartments"
                            [value]="department.department_id"
                    >
                        {{ department.department_name }}
                    </option>
                </select>
            </ng-template>

            <ng-template ngSwitchCase="division">
                <h1>{{ 'MODALS.HEADERS.ADD_DIVISION' | translate }}</h1>
                <h2>{{ 'MODALS.FIELDS.SELECT.DEPARTMENTS' | translate }}</h2>
                <select [(ngModel)]="selectedDepartmentWithDivisions"
                        class="form-select">
                    <option [ngValue]="undefined"
                            hidden>{{ 'MODALS.FIELDS.SELECT.DEPARTMENTS' | translate }}
                    </option>
                    <option *ngIf="!allDepartments.length"
                            disabled>{{ 'EMPTY_LISTS.EMPTY' | translate }}
                    </option>
                    <option *ngFor="let department of allDepartments"
                            [ngValue]="department"
                    >
                        {{ department.department_name }}
                    </option>
                </select>

                <div *ngIf="selectedDepartmentWithDivisions"
                     class="mb-3">
                    <h2 class="mt-1">{{ 'MODALS.FIELDS.SELECT.DIVISION' | translate }}</h2>
                    <div *ngFor="let divisionItemCont of selectedDepartmentWithDivisions.divisions"
                         class="division-item">
                        <ng-container
                                *ngTemplateOutlet="division; context: {divisionItem: divisionItemCont}"></ng-container>
                    </div>
                    <i *ngIf="!selectedDepartmentWithDivisions.divisions.length">{{ 'EMPTY_LISTS.EMPTY' | translate }}</i>
                </div>
                <ng-template #division
                             let-divisionItem="divisionItem">
                    <div>
                        <div class="division-item item-head flex-display justify-content-between">
                            <div>
                                <i (click)="divisionSlider[divisionItem.id] = !divisionSlider[divisionItem.id]"
                                   *ngIf="divisionItem.subdivision.length"
                                   [class]="divisionSlider[divisionItem.id] ? 'bi bi-caret-down me-1 pointer' : 'bi bi-caret-right me-1 pointer'"
                                ></i>
                                <input (change)="roleKey = divisionItem.id"
                                       class="ms-2 me-1"
                                       name="checkDivision"
                                       type="radio">
                                <i class="bi-people me-1"
                                   ngbTooltip="{{ 'DOCUMENTS.ACCESS.DIVISION' | translate }}"
                                ></i>
                                <span>{{ divisionItem.name }}</span>
                            </div>
                        </div>

                        <div *ngIf="divisionSlider[divisionItem.id]">
                            <div *ngFor="let divisionItem of divisionItem.subdivision"
                                 class="subdivision">
                                <ng-container
                                        *ngTemplateOutlet="division; context: {divisionItem: divisionItem}"></ng-container>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ng-template>
        </ng-container>

        <div class="input-group mt-3">
            <label class="input-group-text"
                   for="is_read_all">
                {{ 'DOCUMENTS.ACCESS.is_read_all' | translate }}
            </label>
            <select #readAll
                    class="form-select"
                    id="is_read_all"
                    name="is_read_all"
            >
                <option hidden
                        selected
                        value="">Выбрать права
                </option>
                <option value="succession">{{ 'TASKS.SETTINGS.ACCESS.VALUE.succession'| translate }}</option>
                <option value="allowed">{{ 'TASKS.SETTINGS.ACCESS.VALUE.allowed'| translate }}</option>
                <option value="denied">{{ 'TASKS.SETTINGS.ACCESS.VALUE.denied'| translate }}</option>
            </select>
        </div>
        <div class="input-group mt-3">
            <label class="input-group-text"
                   for="is_upload_file">
                {{ 'DOCUMENTS.ACCESS.is_upload_file' | translate }}
            </label>
            <select #uploadFile
                    class="form-select"
                    id="is_upload_file"
                    name="is_upload_file"
            >
                <option hidden
                        selected
                        value="">Выбрать права
                </option>
                <option value="succession">{{ 'TASKS.SETTINGS.ACCESS.VALUE.succession'| translate }}</option>
                <option value="allowed">{{ 'TASKS.SETTINGS.ACCESS.VALUE.allowed'| translate }}</option>
                <option value="denied">{{ 'TASKS.SETTINGS.ACCESS.VALUE.denied'| translate }}</option>
            </select>
        </div>
        <div class="input-group mt-3">
            <label class="input-group-text"
                   for="is_create_folder">
                {{ 'DOCUMENTS.ACCESS.is_create_folder' | translate }}
            </label>
            <select #createFolder
                    class="form-select"
                    id="is_create_folder"
                    name="is_create_folder"
            >
                <option hidden
                        selected
                        value="">Выбрать права
                </option>
                <option value="succession">{{ 'TASKS.SETTINGS.ACCESS.VALUE.succession'| translate }}</option>
                <option value="allowed">{{ 'TASKS.SETTINGS.ACCESS.VALUE.allowed'| translate }}</option>
                <option value="denied">{{ 'TASKS.SETTINGS.ACCESS.VALUE.denied'| translate }}</option>
            </select>
        </div>
        <div class="input-group mt-3">
            <label class="input-group-text"
                   for="is_edit_signer">
                {{ 'DOCUMENTS.ACCESS.is_edit_signer' | translate }}
            </label>
            <select #editSigner
                    class="form-select"
                    id="is_edit_signer"
                    name="is_edit_signer"
            >
                <option hidden
                        selected
                        value="">Выбрать права
                </option>
                <option value="succession">{{ 'TASKS.SETTINGS.ACCESS.VALUE.succession'| translate }}</option>
                <option value="allowed">{{ 'TASKS.SETTINGS.ACCESS.VALUE.allowed'| translate }}</option>
                <option value="denied">{{ 'TASKS.SETTINGS.ACCESS.VALUE.denied'| translate }}</option>
            </select>
        </div>
        <div class="input-group mt-3">
            <label class="input-group-text"
                   for="is_locked_collection">
                {{ 'DOCUMENTS.ACCESS.is_locked_collection' | translate }}
            </label>
            <select #lockedCollection
                    class="form-select"
                    id="is_locked_collection"
                    name="is_locked_collection"
            >
                <option hidden
                        selected
                        value="">Выбрать права
                </option>
                <option value="succession">{{ 'TASKS.SETTINGS.ACCESS.VALUE.succession'| translate }}</option>
                <option value="allowed">{{ 'TASKS.SETTINGS.ACCESS.VALUE.allowed'| translate }}</option>
                <option value="denied">{{ 'TASKS.SETTINGS.ACCESS.VALUE.denied'| translate }}</option>
            </select>
        </div>
        <div class="input-group mt-3">
            <label class="input-group-text"
                   for="is_edit_settings">
                {{ 'DOCUMENTS.ACCESS.is_edit_settings' | translate }}
            </label>
            <select #editSettings
                    class="form-select"
                    id="is_edit_settings"
                    name="is_edit_settings"
            >
                <option hidden
                        selected
                        value="">Выбрать права
                </option>
                <option value="succession">{{ 'TASKS.SETTINGS.ACCESS.VALUE.succession'| translate }}</option>
                <option value="allowed">{{ 'TASKS.SETTINGS.ACCESS.VALUE.allowed'| translate }}</option>
                <option value="denied">{{ 'TASKS.SETTINGS.ACCESS.VALUE.denied'| translate }}</option>
            </select>
        </div>
        <div class="input-group mt-3">
            <label class="input-group-text"
                   for="is_delete">
                {{ 'DOCUMENTS.ACCESS.is_delete' | translate }}
            </label>
            <select #isDelete
                    class="form-select"
                    id="is_delete"
                    name="is_delete"
            >
                <option hidden
                        selected
                        value="">Выбрать права
                </option>
                <option value="succession">{{ 'TASKS.SETTINGS.ACCESS.VALUE.succession'| translate }}</option>
                <option value="allowed">{{ 'TASKS.SETTINGS.ACCESS.VALUE.allowed'| translate }}</option>
                <option value="denied">{{ 'TASKS.SETTINGS.ACCESS.VALUE.denied'| translate }}</option>
            </select>
        </div>
        <div class="input-group mt-3">
            <label class="input-group-text"
                   for="is_read_approved_doc">
                {{ 'DOCUMENTS.ACCESS.is_read_approved_doc' | translate }}
            </label>
            <select #isReadApprovedDoc
                    class="form-select"
                    id="is_read_approved_doc"
                    name="is_read_approved_doc"
            >
                <option hidden
                        selected
                        value="">Выбрать права
                </option>
                <option value="succession">{{ 'TASKS.SETTINGS.ACCESS.VALUE.succession'| translate }}</option>
                <option value="allowed">{{ 'TASKS.SETTINGS.ACCESS.VALUE.allowed'| translate }}</option>
                <option value="denied">{{ 'TASKS.SETTINGS.ACCESS.VALUE.denied'| translate }}</option>
            </select>
        </div>
        <div class="input-group mt-3">
            <label class="input-group-text"
                   for="is_edit_approver">
                {{ 'DOCUMENTS.ACCESS.is_edit_approver' | translate }}
            </label>
            <select #isEditApprover
                    class="form-select"
                    id="is_edit_approver"
                    name="is_edit_approver"
            >
                <option hidden
                        selected
                        value="">Выбрать права
                </option>
                <option value="succession">{{ 'TASKS.SETTINGS.ACCESS.VALUE.succession'| translate }}</option>
                <option value="allowed">{{ 'TASKS.SETTINGS.ACCESS.VALUE.allowed'| translate }}</option>
                <option value="denied">{{ 'TASKS.SETTINGS.ACCESS.VALUE.denied'| translate }}</option>
            </select>
        </div>
        <div class="input-group mt-3">
            <label class="input-group-text"
                   for="is_edit_property">
                {{ 'DOCUMENTS.ACCESS.is_edit_property' | translate }}
            </label>
            <select #isEditProperty
                    class="form-select"
                    id="is_edit_property"
                    name="is_edit_property"
            >
                <option hidden
                        selected
                        value="">Выбрать права
                </option>
                <option value="succession">{{ 'TASKS.SETTINGS.ACCESS.VALUE.succession'| translate }}</option>
                <option value="allowed">{{ 'TASKS.SETTINGS.ACCESS.VALUE.allowed'| translate }}</option>
                <option value="denied">{{ 'TASKS.SETTINGS.ACCESS.VALUE.denied'| translate }}</option>
            </select>
        </div>

        <button (click)="addPermissionsToBoard(readAll.value,
                                                uploadFile.value,
                                                createFolder.value,
                                                editSigner.value,
                                                lockedCollection.value,
                                                editSettings.value,
                                                isDelete.value,
                                                isReadApprovedDoc.value,
                                                isEditApprover.value,
                                                isEditProperty.value,
                                                modal)"
                [disabled]="isLockButton"
                class="btn btn-block btn-success mt-1"
                data-action='addDepartmentButton'
        >
            <span *ngIf="!isLockButton else refresh">{{ 'DOCUMENTS.BUTTONS.ADD' | translate }}</span>
        </button>
    </div>
</ng-template>

<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>
